import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6893414c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "filters" }
const _hoisted_2 = { class: "overlay-panel-header" }
const _hoisted_3 = { class: "caption mb-s2" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["for"]

import { useI18n } from 'vue-i18n';
import { ref } from 'vue';
import Icon from '@/components/icon/Icon.vue';
import { PORTFOLIOS_FILTER_BY } from '@/views/pages/liquidity/portfolios/portfolio/models/constants';
import { usePortfoliosFilter } from '@/store/modules/portfolios/usePortfoliosFilter';


export default /*#__PURE__*/_defineComponent({
  __name: 'portfoliosFilter',
  emits: ["change"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'change', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const { t } = useI18n();
const { filterBy } = usePortfoliosFilter();

const filterPanel = ref();
const filterByPrev = ref(filterBy.value);
const filterField = [
  { name: t('portfolio.filter.crosschain'), value: PORTFOLIOS_FILTER_BY.crosschain },
  { name: t('portfolio.filter.local'), value: PORTFOLIOS_FILTER_BY.local },
  { name: t('portfolio.filter.all'), value: PORTFOLIOS_FILTER_BY.all },
];
const toggleFilterPanel = event => filterPanel.value.toggle(event);
const onChangeFilter = (value, event) => {
  if (event) {
    event.preventDefault();
  }
  if (filterByPrev.value === value) return;

  filterBy.value = value;
  filterByPrev.value = value;
  emits('change', filterBy.value);
  filterPanel.value.hide();
};

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Button, {
      class: "button-base button-icon",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (toggleFilterPanel($event))),
      "aria-controls": "filterPanel"
    }, {
      default: _withCtx(() => [
        _createVNode(Icon, {
          name: "filter",
          size: "20"
        })
      ]),
      _: 1
    }),
    _createVNode(_component_OverlayPanel, {
      ref_key: "filterPanel",
      ref: filterPanel,
      id: "filterPanel",
      "show-close-icon": "",
      class: "dropdown-list"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('portfolio.filter.header')), 1),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('portfolio.filter.title')), 1),
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(filterField, (filter) => {
            return _createElementVNode("div", {
              class: "text-sm dropdown-li p-dropdown-item",
              key: filter.value,
              onClick: ($event: any) => (onChangeFilter(filter.value, $event))
            }, [
              _createVNode(_component_RadioButton, {
                inputId: filter.value,
                name: "filter",
                value: filter.value,
                modelValue: _unref(filterBy),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(filterBy) ? (filterBy).value = $event : null))
              }, null, 8, ["inputId", "value", "modelValue"]),
              _createElementVNode("label", {
                for: filter.value
              }, _toDisplayString(filter.name), 9, _hoisted_5)
            ], 8, _hoisted_4)
          }), 64))
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}
}

})